"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticEventSink = void 0;
exports.addSink = addSink;
exports.logEvent = logEvent;
exports.logImpression = logImpression;
exports.logInteraction = logInteraction;
exports.logCompletion = logCompletion;
const event_1 = require("./event");
const factory_1 = require("./factory");
let sinks = [];
function addSink(sink) {
    sinks.push(sink);
}
class AnalyticEventSink {
    constructor() {
        this.interceptors = [];
    }
    addInterceptor(interceptor) {
        this.interceptors.push(interceptor);
    }
    async add(event) {
        const original = event;
        for (const interceptor of this.interceptors) {
            event = await interceptor.intercept(event.clone());
        }
        await this.onAdd(original, event);
    }
}
exports.AnalyticEventSink = AnalyticEventSink;
async function logEvent(event) {
    const ev = await (0, factory_1.getAnalyticEventFactory)().createEvent(event);
    const promises = [];
    for (const sink of sinks) {
        promises.push(sink.add(ev));
    }
    await Promise.all(promises);
}
async function logImpression(element) {
    await logEvent({
        type: event_1.AnalyticEventType.impression,
        element: element,
    });
}
async function logInteraction(element) {
    await logEvent({
        type: event_1.AnalyticEventType.interaction,
        element: element,
    });
}
async function logCompletion(element) {
    await logEvent({
        type: event_1.AnalyticEventType.completion,
        element: element,
    });
}
//# sourceMappingURL=sink.js.map